"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalculateUtils = exports.VIRTUAL_CURRENCY = exports.PositionSideChanged = void 0;
const trade_utils_lib_1 = require("trade_utils_lib");
const HiddenDemoMode_1 = require("../../FuturesConfig/Preferences/HiddenDemoMode");
const SymbolComponent_1 = require("../../FuturesConfig/SymbolComponent");
const interface_1 = require("../../../interface");
// export interface LiquidationParams {
//     symbolInfo: Pick<ExchangeSymbol, "precision" | "amount">;
//     // 逐仓/全仓
//     // marginType: FutureMarginType;
//     orderType: CustomOrderType;
//     orderSide: CustomOrderSide;
//     // 是否是仅减仓，仅减仓模式下不需要给出仓位反向的提示
//     reduceOnly: boolean;
//     postOnly: boolean;
//     /** 仅限价单有用 */
//     investSide: InvestSymbolSide;
//     price: string;
//     qty: string;
//     curPrice: string;
//     /**当前可用 */
//     available: string;
// }
const OpenCostRatio = 0.001;
var PositionSideChanged;
(function (PositionSideChanged) {
    /**仓位方向不变，为用户输入的原始值 */
    PositionSideChanged["KEEP_ORIGIN"] = "KEEP_ORIGIN";
    /**仓位方向不变，但是存在部分平仓的行为 */
    PositionSideChanged["PARTIAL_CLOSING"] = "PARTIAL_CLOSING";
    /**用户下的单，刚好能完全平仓 */
    PositionSideChanged["FULL_CLOSING"] = "FULL_CLOSING";
    /**仓位方向发生改变 */
    PositionSideChanged["REVERSE"] = "REVERSE";
})(PositionSideChanged = exports.PositionSideChanged || (exports.PositionSideChanged = {}));
/**虚拟币的名字 */
exports.VIRTUAL_CURRENCY = "VUJZYX";
var CalculateUtils;
(function (CalculateUtils) {
    CalculateUtils.isFuturesLimit = (orderType) => {
        return orderType === interface_1.CustomOrderType.LIMIT || orderType === interface_1.CustomOrderType.POST;
    };
    CalculateUtils.isFuturesMarket = (orderType) => {
        return orderType === interface_1.CustomOrderType.MARKET_AMT || orderType === interface_1.CustomOrderType.MARKET_QTY || orderType === interface_1.CustomOrderType.ATS;
    };
    /**是否是Reduce only */
    function isOrderReduceOnly(side, position_side) {
        return ((side === interface_1.CustomOrderSide.SELL && position_side === interface_1.FuturePositionSide.LONG) ||
            (side === interface_1.CustomOrderSide.BUY && position_side === interface_1.FuturePositionSide.SHORT));
    }
    CalculateUtils.isOrderReduceOnly = isOrderReduceOnly;
    /**判断双向持仓下是否是平仓操作 */
    function isClosePosition(positionMode, side, position_side) {
        if (positionMode === interface_1.OrderPositionMode.BUYSELL) {
            return false;
        }
        return isOrderReduceOnly(side, position_side);
    }
    CalculateUtils.isClosePosition = isClosePosition;
    function getBaseInvest(qty, investSide, price, leverage) {
        const baseInvest = new trade_utils_lib_1.SafeDecimal(qty);
        switch (investSide) {
            case interface_1.InvestSymbolSide.quote:
                return baseInvest.div(new trade_utils_lib_1.SafeDecimal(price));
            case interface_1.InvestSymbolSide.cost:
                return baseInvest.mul(new trade_utils_lib_1.SafeDecimal(leverage)).div(new trade_utils_lib_1.SafeDecimal(price));
        }
        return baseInvest;
    }
    function getTradeQty(params) {
        const { qty, price, orderSide, curPrice, investSide, leverage } = params;
        const realPrice = !!price ? price : curPrice;
        let _realQty = getBaseInvest(qty, investSide, realPrice, leverage);
        if (orderSide === interface_1.CustomOrderSide.SELL) {
            _realQty = _realQty.mul(-1);
        }
        return _realQty.toString();
    }
    CalculateUtils.getTradeQty = getTradeQty;
    function getTradePrice(params) {
        const { orderType, price, curPrice } = params;
        const isLimitOrder = CalculateUtils.isFuturesLimit(orderType);
        return isLimitOrder ? price : curPrice;
    }
    CalculateUtils.getTradePrice = getTradePrice;
    function getPositionChanged(userQty, reduceOnly, lastPosition) {
        let qty = new trade_utils_lib_1.SafeDecimal(userQty);
        if (lastPosition) {
            // 已经存在仓位，需要判断最终的仓位方向
            const { positionQuantity, position_side } = lastPosition;
            qty = qty.add(positionQuantity);
            if (qty.eq(0)) {
                // 刚好完全平仓，啥也不做
                return PositionSideChanged.FULL_CLOSING;
            }
            const mergedSide = qty.gt(0) ? interface_1.FuturePositionSide.LONG : interface_1.FuturePositionSide.SHORT;
            if (mergedSide === position_side) {
                // 仓位方向不变
                if (qty.abs().gt(new trade_utils_lib_1.SafeDecimal(positionQuantity).abs())) {
                    return PositionSideChanged.KEEP_ORIGIN;
                }
                else {
                    // 同方向减仓
                    // 计算减仓的均价：直接使用历史仓位的持仓均价
                    return PositionSideChanged.PARTIAL_CLOSING;
                }
            }
            else {
                // 仓位反向
                // 直接使用最新的价格
                return reduceOnly ? PositionSideChanged.FULL_CLOSING : PositionSideChanged.REVERSE;
            }
        }
        return PositionSideChanged.KEEP_ORIGIN;
    }
    CalculateUtils.getPositionChanged = getPositionChanged;
    function mapOrderTypeToUI(type) {
        return CalculateUtils.isFuturesLimit(type) ? interface_1.FuturesOrderTypeUI.limit : interface_1.FuturesOrderTypeUI.market;
    }
    CalculateUtils.mapOrderTypeToUI = mapOrderTypeToUI;
    function getPositionSide(positionMode, reduceOnly, side) {
        if (positionMode === interface_1.OrderPositionMode.BUYSELL) {
            if (reduceOnly) {
                return side === interface_1.CustomOrderSide.BUY ? interface_1.FuturePositionSide.SHORT : interface_1.FuturePositionSide.LONG;
            }
            return interface_1.FuturePositionSide.BOTH;
        }
        if (reduceOnly) {
            return side === interface_1.CustomOrderSide.BUY ? interface_1.FuturePositionSide.SHORT : interface_1.FuturePositionSide.LONG;
        }
        return side === interface_1.CustomOrderSide.BUY ? interface_1.FuturePositionSide.LONG : interface_1.FuturePositionSide.SHORT;
    }
    CalculateUtils.getPositionSide = getPositionSide;
    /**获取预估名义价值 */
    function getEstNotional(params) {
        const { positionMode, positionQty, reversePositionQty, invest, orderSide, reduceOnly, precision, leverageRow, amountPrecision, marginType, markPrice, esMarkPrice, investSide, avgMarkPrice, isLimitOrder, } = params;
        // 获取当前持仓总量
        const currentQty = (() => {
            const qty = positionQty !== null && positionQty !== void 0 ? positionQty : 0;
            const qtyD = new trade_utils_lib_1.SafeDecimal(qty);
            // 全仓模式
            if (marginType === interface_1.FutureMarginType.CROSS && positionMode === interface_1.OrderPositionMode.OPENCLOSE) {
                // 全仓模式，计算名义价值时需要加上反向仓位
                const rQty = reversePositionQty !== null && reversePositionQty !== void 0 ? reversePositionQty : 0;
                return qtyD.abs().add(new trade_utils_lib_1.SafeDecimal(rQty).abs());
            }
            // 逐仓模式只需要计算同向仓位的名义价值
            if (orderSide === interface_1.CustomOrderSide.BUY) {
                return qtyD.gt(0) ? qtyD : new trade_utils_lib_1.SafeDecimal(0);
            }
            return qtyD.lt(0) ? qtyD.abs() : new trade_utils_lib_1.SafeDecimal(0);
        })();
        // 获取当前的仓位符号
        const flag = (() => {
            if (positionMode === interface_1.OrderPositionMode.BUYSELL) {
                return orderSide === interface_1.CustomOrderSide.BUY ? 1 : -1;
            }
            return reduceOnly ? -1 : 1;
        })();
        // 获取当前下单的量 或者 仓位价值
        const newInvest = new trade_utils_lib_1.SafeDecimal(invest).mul(flag);
        /**当前仓位占用的名义价值(需要使用当前的标记价格计算当前仓位的名义价值) */
        const positionNotional = currentQty.mul(markPrice).abs();
        /**
         * 当前杠杆的最大名义价值
         * 如果是限价单并且不存在仓位，则允许下最大名义价值，否则走市价单的计算逻辑
         */
        const maxNotionLimit = isLimitOrder && positionNotional.eq(0)
            ? new trade_utils_lib_1.SafeDecimal(leverageRow === null || leverageRow === void 0 ? void 0 : leverageRow.notional_limit)
            : new trade_utils_lib_1.SafeDecimal(leverageRow === null || leverageRow === void 0 ? void 0 : leverageRow.notional_limit).mul(0.98);
        /**可用最大名义价值 */
        const availableNotionLimit = maxNotionLimit.sub(positionNotional);
        /**是否可以再下单 */
        const canTrade = availableNotionLimit.gt(0) && !markPrice.eq(0) && !esMarkPrice.eq(0);
        // 相加计算价值 向上取整
        return investSide === interface_1.InvestSymbolSide.base
            ? [
                trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(currentQty.add(newInvest).mul(esMarkPrice), precision, trade_utils_lib_1.SafeDecimal.ROUND_CEIL),
                // 计算当前阶梯档位下最多可以投入的base量
                // (currentQty + base * flag) * price = notional_limit
                // (currentQty + base * flag)  = notional_limit / price
                // max_base  = ((notional_limit*0.98) / price - currentQty)/flag
                canTrade
                    ? trade_utils_lib_1.SafeDecimal.min(availableNotionLimit.div(avgMarkPrice), availableNotionLimit.div(esMarkPrice))
                        .div(flag)
                        .toFixed(amountPrecision !== null && amountPrecision !== void 0 ? amountPrecision : 2, trade_utils_lib_1.SafeDecimal.ROUND_DOWN)
                    : "0",
            ]
            : [
                // 预估成交后的名义价值
                trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(currentQty.mul(esMarkPrice).add(newInvest), precision, trade_utils_lib_1.SafeDecimal.ROUND_CEIL),
                //   获取最大可投入的额 quote
                canTrade ? availableNotionLimit.toFixed(precision !== null && precision !== void 0 ? precision : 2, trade_utils_lib_1.SafeDecimal.ROUND_DOWN) : "0",
            ];
    }
    CalculateUtils.getEstNotional = getEstNotional;
    /**判断仓位模式是否是双向持仓 */
    function isOpenCloseMode(position_mode) {
        return (position_mode || "").toUpperCase() === interface_1.OrderPositionMode.OPENCLOSE;
    }
    CalculateUtils.isOpenCloseMode = isOpenCloseMode;
    /**检测订单或者仓位是否是全仓模式 */
    function isOrderCrossMode(mode) {
        return mode === interface_1.FutureOrderMarginType.CROSS;
    }
    CalculateUtils.isOrderCrossMode = isOrderCrossMode;
    /**获取当前symbol的强平手续费率 */
    function getSymbolLiqFeeRate(symbol) {
        var _a;
        const symbolInfo = SymbolComponent_1.SymbolPerpetualUSDTComponent.getExchangeSymbol(symbol);
        return ((_a = symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.originData) === null || _a === void 0 ? void 0 : _a.liquidation_fee_rate) || "";
    }
    CalculateUtils.getSymbolLiqFeeRate = getSymbolLiqFeeRate;
    /**判断是否是虚拟币，判断逻辑加入了“隐藏模拟模式” */
    function isVirtualSymbolInHiddenDemoMode(symbol) {
        // 如果开启了“隐藏模拟模式”，那么“无脑”返回 false（即：无论什么 symbol 都不是虚拟币）
        if (HiddenDemoMode_1.hiddenDemoMode.isHiddenDemoMode) {
            return false;
        }
        return CalculateUtils.isVirtualSymbol(symbol);
    }
    CalculateUtils.isVirtualSymbolInHiddenDemoMode = isVirtualSymbolInHiddenDemoMode;
    /**判断是否是虚拟币 */
    function isVirtualSymbol(symbol) {
        return (symbol || "").includes(exports.VIRTUAL_CURRENCY);
    }
    CalculateUtils.isVirtualSymbol = isVirtualSymbol;
    function getDisplayCurrency(currency) {
        if (HiddenDemoMode_1.hiddenDemoMode.isHiddenDemoMode) {
            return currency === exports.VIRTUAL_CURRENCY ? "USDT" : currency;
        }
        return currency === exports.VIRTUAL_CURRENCY ? "PUSD" : currency;
    }
    CalculateUtils.getDisplayCurrency = getDisplayCurrency;
    /**计算市价的冲击均价 */
    function calcMarketImpactAvgPrice(latestPrice, orderSide) {
        if (orderSide === interface_1.CustomOrderSide.BUY) {
            return latestPrice.mul(new trade_utils_lib_1.SafeDecimal(1).add(OpenCostRatio));
        }
        return latestPrice.mul(new trade_utils_lib_1.SafeDecimal(1).sub(OpenCostRatio));
    }
    CalculateUtils.calcMarketImpactAvgPrice = calcMarketImpactAvgPrice;
    /**获取价差，用来计算开仓损失 */
    function getPriceDiff({ latestPrice, orderSide, markPrice, }) {
        // 计算价差
        let priceDiff = new trade_utils_lib_1.SafeDecimal(0);
        if (!latestPrice.gt(0)) {
            return priceDiff;
        }
        // step1 计算价差
        // 需要用到冲击均价
        const impactAvgPrice = calcMarketImpactAvgPrice(latestPrice, orderSide);
        if (orderSide === interface_1.CustomOrderSide.BUY) {
            if (impactAvgPrice.gt(markPrice)) {
                priceDiff = impactAvgPrice.sub(markPrice);
            }
        }
        else {
            if (impactAvgPrice.lt(markPrice)) {
                priceDiff = markPrice.sub(impactAvgPrice);
            }
        }
        return priceDiff;
    }
    CalculateUtils.getPriceDiff = getPriceDiff;
    /**
     * 获取逐仓被平仓之后可以释放的Available
     *
     * 可用保证金max(free + debts + 总浮动盈亏 - 总占用保证金, 0)
     */
    function getPositionReleaseAvailable(position) {
        const { balances, currency } = position;
        const pBalance = balances === null || balances === void 0 ? void 0 : balances.find((it) => it.coin === currency);
        if (!pBalance) {
            return new trade_utils_lib_1.SafeDecimal(0);
        }
        const { free, unrealized_pnl } = pBalance;
        // 修改逐仓释放保证金的算法
        const availableD = new trade_utils_lib_1.SafeDecimal(free).add(new trade_utils_lib_1.SafeDecimal(unrealized_pnl));
        // FIXME: 逐仓释放的占用目前添加了0.98的buffer
        return trade_utils_lib_1.SafeDecimal.max(availableD.mul(0.98), 0);
    }
    /**计算反手最大可买 */
    function calcReverseMaxCanBuy({ 
    // latestPrice,
    markPrice, tradePrice, availableMargin, reverseQtyAbs, totalUPNL, totalInitMargin, position, priceDiff, }) {
        const isCross = position.isolated_mode === interface_1.FutureOrderMarginType.CROSS;
        const leverage = new trade_utils_lib_1.SafeDecimal(position.leverage);
        const PRICE_DIV_LEVERAGE = tradePrice.div(leverage);
        let maxInvest = new trade_utils_lib_1.SafeDecimal(0);
        if (isCross) {
            // 全仓
            if (availableMargin.gt(0)) {
                // available - maxInvest * 价差 >= (maxInvest - abs(反向仓位)) * 预估成交价格 / 当前杠杆
                // (available + abs(反向仓位) * 预估成交价格 / 当前杠杆)/(预估成交价格 / 当前杠杆 +  价差)   >= maxInvest
                maxInvest = availableMargin.add(reverseQtyAbs.mul(PRICE_DIV_LEVERAGE)).div(PRICE_DIV_LEVERAGE.add(priceDiff));
            }
            else {
                // (总未实现盈亏 * 反向仓位占用/全仓总占用 + 仓位释放的保证金 + available )/ (价差 +  预估成交价格 / 当前杠杆) >= maxInvest
                const reverseMargin = reverseQtyAbs.mul(markPrice).div(leverage);
                maxInvest = trade_utils_lib_1.SafeDecimal.max(totalUPNL
                    .mul(reverseMargin.div(totalInitMargin))
                    .add(reverseMargin)
                    .add(availableMargin)
                    .div(PRICE_DIV_LEVERAGE.add(priceDiff)), 0);
            }
        }
        else {
            // 逐仓
            // 计算逐仓释放的保证金
            const releaseMargin = getPositionReleaseAvailable(position);
            const totalMargin = availableMargin.add(releaseMargin);
            if (totalMargin.gt(0)) {
                maxInvest = totalMargin.div(PRICE_DIV_LEVERAGE.add(priceDiff));
            }
        }
        return maxInvest.add(reverseQtyAbs);
    }
    CalculateUtils.calcReverseMaxCanBuy = calcReverseMaxCanBuy;
})(CalculateUtils = exports.CalculateUtils || (exports.CalculateUtils = {}));
